angular.module('admin.directives')

  .directive('address', ['HelperService', function(helpers){
    return {
      restrict: 'A',
      controllerAs: 'addressCtrl',
      bindToController: {
        address: '=',
        brief: '@'
      },
      controller: angular.noop,
      templateUrl: function(el, attrs){
        if(!helpers.isFalsey(attrs.brief))
          return '/admin/templates/partials/address-brief.html';

        return '/admin/templates/partials/address.html';
      },
      scope: {}
    }

  }]);
